export class RegisterUserResponse {
    /**
     * Identifies the user that was attempted to be registered
     */
    constructor(userId) {
        this.userId = userId;
    }
}
